var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { forwardRef } from 'react';
import { MdContentCopy } from 'react-icons/md';
import copyToClipboard from 'clipboard-copy';
import { Tooltip, Button, Box } from "./..";
import { useToggle } from "../../hooks/useToggle";
var ClipboardIcon = function (_a) {
    var iconPosition = _a.iconPosition;
    return (React.createElement(Box, { lss: {
            display: 'inline',
            pl: iconPosition === 'right' ? 'sm' : 0,
            pr: iconPosition === 'left' ? 'sm' : 0
        } },
        React.createElement(MdContentCopy, { size: 16 })));
};
export var ClipboardButton = forwardRef(function (_a, ref) {
    var copyText = _a.copyText, _b = _a.emphasis, emphasis = _b === void 0 ? 'high' : _b, palette = _a.palette, _c = _a.scale, scale = _c === void 0 ? 'sm' : _c, _d = _a.tooltipText, tooltipText = _d === void 0 ? 'Copied!' : _d, _e = _a.buttonText, buttonText = _e === void 0 ? 'Copy' : _e, _f = _a.showIcon, showIcon = _f === void 0 ? true : _f, _g = _a.iconPosition, iconPosition = _g === void 0 ? 'right' : _g, props = __rest(_a, ["copyText", "emphasis", "palette", "scale", "tooltipText", "buttonText", "showIcon", "iconPosition"]);
    var _h = __read(useToggle(), 2), tooltip = _h[0], toggleTooltip = _h[1];
    var handleClick = function () {
        if (copyText) {
            copyToClipboard(copyText);
        }
        toggleTooltip();
        setTimeout(function () { return toggleTooltip(); }, 1500);
    };
    var content = (React.createElement(Button, __assign({}, props, { ref: ref, palette: palette, emphasis: emphasis, scale: scale, onClick: handleClick }),
        showIcon && iconPosition === 'left' && (React.createElement(ClipboardIcon, { iconPosition: iconPosition })),
        buttonText,
        showIcon && iconPosition === 'right' && (React.createElement(ClipboardIcon, { iconPosition: iconPosition }))));
    return (React.createElement(React.Fragment, null, tooltip ? (React.createElement(Tooltip, { title: copyText && copyText.length > 0
            ? tooltipText
            : 'No new text was copied.', placement: "top", delay: 1500 }, content)) : (content)));
});
//# sourceMappingURL=ClipboardButton.js.map